import { HorizontalContainer, Panel } from '@/components';
import { InfoIcon } from '@/components/Icons';
import { cn } from '@/lib/cn';

import { R } from '@/caregiverSpace/resources/Texts.resx';

type DeletedProfilePanelProps = {
    isPet: boolean;
    className?: string;
};

export const DeletedProfilePanel = ({
    isPet,
    className,
}: DeletedProfilePanelProps) => {
    return (
        <Panel type="error" className={cn('h-fit w-fit px-4 py-2', className)}>
            <HorizontalContainer className="items-center">
                <InfoIcon variant="error" />
                <span>
                    {isPet ? R.PetAccountDeleted : R.PatientAccountDeleted}
                </span>
            </HorizontalContainer>
        </Panel>
    );
};
